const allGenders = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
];

export default allGenders;
